import { render, staticRenderFns } from "./VendorsProfileOverview.vue?vue&type=template&id=07c54f64&scoped=true"
import script from "./VendorsProfileOverview.vue?vue&type=script&lang=js"
export * from "./VendorsProfileOverview.vue?vue&type=script&lang=js"
import style0 from "./VendorsProfileOverview.vue?vue&type=style&index=0&id=07c54f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c54f64",
  null
  
)

export default component.exports